<script lang="ts">
	import Section from "#lib/web-ui/primitives/section.svelte";
</script>

<Section
	class="w-full bg-[radial-gradient(ellipse_at_50%_40%,var(--color-primary),hsl(16,100%,40%,0.8),hsl(16,100%,40%))]"
>
	<div class="relative py-18">
		<div class="mx-auto max-w-3xl text-center">
			<h1
				class="text-border mt-10 text-4xl font-bold tracking-tight drop-shadow-md sm:text-5xl"
			>
				Get Paid to Find
				<br class="hidden sm:inline" />
				<span class="text-7xl text-white drop-shadow-md">Distressed Properties</span>
			</h1>

			<p
				class="mt-3 text-xl leading-8 font-semibold text-white
                drop-shadow-md"
			>
				Earn extra income by simply taking photos of homes in need of repair
			</p>
		</div>
	</div>
</Section>
